"use client";

import { useProductTileContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
import React from "react";

export const LoggedOutProductTileUpperContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const containerRef = useProductTileContainerRef();
  return (
    <div ref={containerRef} className="relative">
      {children}
    </div>
  );
};
